__turbopack_context__.v({
  "menu": "MenuList-module__-yX_2q__menu",
  "menuItem": "MenuList-module__-yX_2q__menuItem",
});
